var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSideBarFootLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 176.092,
    height: 19,
    viewBox: "0 0 176.092 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2889",
    "data-name": "Group 2889",
    transform: "translate(-149 -789.841)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Powered_by",
    "data-name": "Powered by",
    transform: "translate(149 804.841)",
    fill: "#0c4767",
    fontSize: 14,
    fontFamily: "SegoeUI, Segoe UI",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Powered by")), /*#__PURE__*/React.createElement("g", {
    id: "Group_2888",
    "data-name": "Group 2888",
    transform: "translate(235 790.841)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1431",
    "data-name": "Group 1431",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1429",
    "data-name": "Group 1429",
    transform: "translate(0.984 0.561)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2246",
    "data-name": "Path 2246",
    d: "M351.914,412.569c1.056-.046,2.474-.3,2.943.927a2.661,2.661,0,0,1-3.379.6,1.891,1.891,0,0,1-.993-1.082.86.86,0,0,1,.045-.608A3.567,3.567,0,0,0,351.914,412.569Z",
    transform: "translate(-347.538 -402.605)",
    fill: "#fe9920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2247",
    "data-name": "Path 2247",
    d: "M303.582,369.818a2.418,2.418,0,0,1,.237-2.133,2.658,2.658,0,0,1,1.757-1.242,1.776,1.776,0,0,0,.029,2.264c.033.041.068.08.1.118a3.642,3.642,0,0,0-1.1,2.185A1.9,1.9,0,0,1,303.582,369.818Z",
    transform: "translate(-303.433 -359.488)",
    fill: "#fe9920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2248",
    "data-name": "Path 2248",
    d: "M340.443,265.843c-2,.24-3.125,2.228-4.817,3.087a3.048,3.048,0,0,1-1.239.324.242.242,0,0,0,.071-.129c.033-.184-.166-.374-.447-.424s-.534.057-.567.241a.285.285,0,0,0,.092.246,3.46,3.46,0,0,1-2.877-3.344,2.77,2.77,0,0,1,.7-1.706,1.6,1.6,0,0,0-.015.234,2.1,2.1,0,0,0,1.024,1.57,3.233,3.233,0,0,0,4.26-.467,1.345,1.345,0,0,0,.978-.955c.164-.88-.886-1.762-1.006-1.86l-.021-.016a4.989,4.989,0,1,1,8.531-3.524,5.466,5.466,0,0,1-1.515,3.575l.017.015a1.146,1.146,0,0,0-.1,1.459,2.228,2.228,0,0,0,1.94.411,3.342,3.342,0,0,0,2.28-1.477,1.89,1.89,0,0,0-.167-2.237,1.893,1.893,0,0,1,2.085,1.233,2.858,2.858,0,0,1-.138,2.1.3.3,0,0,0-.051.11,3.46,3.46,0,0,1-.425.672,3.753,3.753,0,0,1-1.888,1.2.252.252,0,0,0,.034-.169c-.033-.184-.287-.292-.567-.241s-.48.241-.446.424a.262.262,0,0,0,.115.166,7.025,7.025,0,0,1-1.555.022C343.318,266.246,341.866,265.672,340.443,265.843Z",
    transform: "translate(-328.972 -254.14)",
    fill: "#fe9920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2249",
    "data-name": "Path 2249",
    d: "M589.38,358.218c.012-.24-.1-.441-.256-.46s-.335.174-.365.435.082.488.253.508a.32.32,0,0,0,.3-.21,4.826,4.826,0,0,1-.711,1.449c-.026.036-.054.068-.081.1a.359.359,0,0,0-.068-.377c-.154-.138-.45-.06-.66.175s-.256.538-.1.676a.358.358,0,0,0,.379.027,4.621,4.621,0,0,1-1.371.885.386.386,0,0,0,.075-.344c-.078-.242-.44-.343-.809-.225s-.605.411-.527.653a.386.386,0,0,0,.261.234,7.663,7.663,0,0,1-2.012.168,9.578,9.578,0,0,1-2.711-.588,5.28,5.28,0,0,0,3-1.3,3.517,3.517,0,0,0,.713-.927,2.716,2.716,0,0,0,2.8-1.746,2,2,0,0,0-.615-2.6,2.412,2.412,0,0,1,2.395,1.512A3.322,3.322,0,0,1,589.38,358.218Z",
    transform: "translate(-563.786 -348.526)",
    fill: "#fe9920"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1430",
    "data-name": "Group 1430"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2250",
    "data-name": "Path 2250",
    d: "M345.9,478.471c-.2-.12-.423-.111-.5.019s.018.333.217.453.423.112.5-.019S346.095,478.591,345.9,478.471Z",
    transform: "translate(-341.786 -463.939)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2251",
    "data-name": "Path 2251",
    d: "M329.145,460.327c-.1.081-.075.267.049.414s.3.2.4.12.075-.267-.049-.414S329.242,460.246,329.145,460.327Z",
    transform: "translate(-326.512 -446.962)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2252",
    "data-name": "Path 2252",
    d: "M600.851,431.6c.2-.12.3-.323.216-.453s-.3-.139-.5-.019-.3.323-.216.453S600.652,431.722,600.851,431.6Z",
    transform: "translate(-580.952 -419.53)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2253",
    "data-name": "Path 2253",
    d: "M434.405,309.4a.851.851,0,1,0,.852.852A.852.852,0,0,0,434.405,309.4Z",
    transform: "translate(-424.512 -305.419)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2254",
    "data-name": "Path 2254",
    d: "M495.708,313.332a.608.608,0,1,0,.608.608A.609.609,0,0,0,495.708,313.332Z",
    transform: "translate(-482.246 -309.105)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2255",
    "data-name": "Path 2255",
    d: "M313.854,252.833a3.291,3.291,0,0,0-3.819-1.335.276.276,0,0,0,0,.528,1.548,1.548,0,0,1,1.2,2.311,2.21,2.21,0,0,1-2.046,1.405,3.573,3.573,0,0,0,.069-2.239,2.562,2.562,0,0,0-3.226-1.548.276.276,0,0,0-.121.458,1.509,1.509,0,0,1,.428,1.964,2.747,2.747,0,0,1-3.025,1.153c-.529-.154-.43-.553-.212-.9l.026.023a6.062,6.062,0,0,0,1.671-3.981,5.588,5.588,0,1,0-9.567,3.955.519.519,0,0,0,.076.065c.295.243.858.857.782,1.268a.538.538,0,0,1-.249.327c-.729-1.619-2.541-1.1-4.009-1.176a1.831,1.831,0,0,1-.447-.077,3.1,3.1,0,0,1,.5-.386.274.274,0,0,0-.276-.472,4.3,4.3,0,0,0-.854.489,1.371,1.371,0,0,1-.4-.953,1.183,1.183,0,0,1,1.217-1.214l.171,0a.274.274,0,0,0,0-.547,2.014,2.014,0,0,0-.216,0c-1.613.041-3.267.513-3.854,2.232-.428,1.254.074,3.283,1.535,3.588a3.606,3.606,0,0,0,.3,1.258A4.227,4.227,0,0,0,294.884,261c1.8-.787,2.893-3.007,5.006-3.091a7.447,7.447,0,0,1,1.508.118.233.233,0,0,0,.154.091,31.959,31.959,0,0,1,4.12,1.1,9.1,9.1,0,0,0,3.164.412,5.747,5.747,0,0,0,4.8-2.69A4.268,4.268,0,0,0,313.854,252.833Zm-21.419,2.821c1.056-.046,2.474-.3,2.943.927a2.661,2.661,0,0,1-3.379.6,1.892,1.892,0,0,1-.993-1.082.859.859,0,0,1,.046-.608A3.574,3.574,0,0,0,292.435,255.654Zm-4.227.366a2.417,2.417,0,0,1,.237-2.133,2.655,2.655,0,0,1,1.757-1.242,1.776,1.776,0,0,0,.029,2.264c.033.041.068.08.1.118a3.644,3.644,0,0,0-1.1,2.185A1.9,1.9,0,0,1,288.208,256.02Zm11.322,1.373c-2,.24-3.125,2.228-4.817,3.087a3.052,3.052,0,0,1-1.239.324.243.243,0,0,0,.071-.129c.033-.184-.167-.374-.447-.424s-.534.057-.567.241a.286.286,0,0,0,.092.246,3.46,3.46,0,0,1-2.877-3.344,2.77,2.77,0,0,1,.7-1.706,1.6,1.6,0,0,0-.015.234,2.1,2.1,0,0,0,1.023,1.57,3.234,3.234,0,0,0,4.26-.467,1.345,1.345,0,0,0,.977-.955c.165-.88-.886-1.762-1.006-1.86l-.021-.016a4.989,4.989,0,1,1,8.531-3.524,5.467,5.467,0,0,1-1.515,3.575l.017.015a1.146,1.146,0,0,0-.1,1.459,2.228,2.228,0,0,0,1.94.411,3.342,3.342,0,0,0,2.28-1.477,1.89,1.89,0,0,0-.168-2.237,1.893,1.893,0,0,1,2.085,1.233,2.856,2.856,0,0,1-.138,2.1.3.3,0,0,0-.051.11,3.463,3.463,0,0,1-.425.672,3.751,3.751,0,0,1-1.888,1.2.251.251,0,0,0,.034-.168c-.033-.184-.287-.292-.567-.241s-.48.241-.446.424a.262.262,0,0,0,.115.166,7.031,7.031,0,0,1-1.555.022C302.4,257.8,300.952,257.222,299.529,257.393Zm14.123-2.011c.012-.24-.1-.441-.256-.46s-.334.174-.365.435.082.488.253.508a.32.32,0,0,0,.3-.21,4.826,4.826,0,0,1-.711,1.449c-.026.036-.054.068-.081.1a.359.359,0,0,0-.068-.377c-.154-.138-.45-.06-.661.175s-.256.538-.1.676a.358.358,0,0,0,.379.027,4.617,4.617,0,0,1-1.37.885.386.386,0,0,0,.075-.344c-.078-.242-.44-.343-.809-.225s-.6.411-.527.653a.385.385,0,0,0,.261.235,7.662,7.662,0,0,1-2.012.168,9.572,9.572,0,0,1-2.711-.588,5.282,5.282,0,0,0,3-1.3,3.505,3.505,0,0,0,.713-.927,2.716,2.716,0,0,0,2.8-1.746,2,2,0,0,0-.615-2.6,2.412,2.412,0,0,1,2.395,1.512A3.321,3.321,0,0,1,313.653,255.382Z",
    transform: "translate(-287.536 -245.082)",
    fill: "#0c4767"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1432",
    "data-name": "Group 1432",
    transform: "translate(31.774 4.945)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2256",
    "data-name": "Path 2256",
    d: "M199.756,531.219l2.884,5.8,2.871-5.8h1.735v8.738h-1.36l-.013-6.529-2.758,5.617h-.961l-2.759-5.617v6.529h-1.385v-8.738Z",
    transform: "translate(-198.009 -531.169)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2257",
    "data-name": "Path 2257",
    d: "M314.1,556.34h-5.018a2.022,2.022,0,0,0,2.06,1.66,2.582,2.582,0,0,0,1.872-.774l.761.811a3.614,3.614,0,0,1-2.747,1.124,3.37,3.37,0,1,1-.037-6.741C313.328,552.421,314.277,553.943,314.1,556.34Zm-1.248-1.049a1.705,1.705,0,0,0-1.847-1.723,1.881,1.881,0,0,0-1.947,1.723Z",
    transform: "translate(-297.05 -550.324)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2258",
    "data-name": "Path 2258",
    d: "M387.535,556.34h-5.018a2.022,2.022,0,0,0,2.06,1.66,2.583,2.583,0,0,0,1.873-.774l.761.811a3.614,3.614,0,0,1-2.747,1.124,3.37,3.37,0,1,1-.038-6.741C386.761,552.421,387.71,553.943,387.535,556.34Zm-1.249-1.049a1.705,1.705,0,0,0-1.847-1.723,1.881,1.881,0,0,0-1.947,1.723Z",
    transform: "translate(-363.393 -550.324)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2259",
    "data-name": "Path 2259",
    d: "M458.413,544.435a3.187,3.187,0,0,1-1.635.487,1.749,1.749,0,0,1-1.86-1.935v-3.445h-.937v-1.074h.937v-1.823h1.423v1.823h1.96v1.074h-1.96v3.183c0,.686.262.9.712.9a2.32,2.32,0,0,0,1-.287Z",
    transform: "translate(-429.265 -536.072)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2260",
    "data-name": "Path 2260",
    d: "M515.484,535.118a4.662,4.662,0,1,1-4.656-4.419A4.481,4.481,0,0,1,515.484,535.118Zm-7.6,0a2.964,2.964,0,0,0,2.971,2.946,2.934,2.934,0,1,0-2.971-2.946Z",
    transform: "translate(-476.416 -530.699)",
    fill: "#fe9920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2261",
    "data-name": "Path 2261",
    d: "M611.757,553.453a1.992,1.992,0,0,0,0,3.969,2.15,2.15,0,0,0,1.8-.786l1.011.836a3.352,3.352,0,0,1-2.9,1.348,3.4,3.4,0,0,1,.025-6.791,3.405,3.405,0,0,1,2.8,1.223l-.986.937A2.289,2.289,0,0,0,611.757,553.453Z",
    transform: "translate(-568.682 -549.97)",
    fill: "#fe9920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2262",
    "data-name": "Path 2262",
    d: "M682.562,544.213a3.216,3.216,0,0,1-1.672.487,1.825,1.825,0,0,1-1.96-2v-3.3h-.936l-.013-1.186h.949v-1.835h1.61v1.835h1.909v1.186H680.54v3.008c0,.636.262.849.7.849a2.266,2.266,0,0,0,.949-.274Z",
    transform: "translate(-631.635 -535.837)",
    fill: "#fe9920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2263",
    "data-name": "Path 2263",
    d: "M736.091,555.413a3.523,3.523,0,1,1-3.508-3.383A3.284,3.284,0,0,1,736.091,555.413Zm-5.405.025a1.89,1.89,0,1,0,1.9-2.022A1.87,1.87,0,0,0,730.686,555.438Z",
    transform: "translate(-677.773 -549.97)",
    fill: "#fe9920"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBarFootLogo);
export default __webpack_public_path__ + "static/media/side_bar_foot_logo.f824a5302c4c60aa6ab282ab4f687264.svg";
export { ForwardRef as ReactComponent };